import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import { CLIENT_ID, CLIENT_SECRET, getSessionData, logout } from './auth';
import { toast } from 'react-toastify';

type LoginData = {
    username: string;
    password: string;
}

//const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:8080' 
const BASE_URL = process.env.REACT_APP_BACKEND_URL ?? 'https://api.instacatalog.com.br'

// Configuração global do axios
axios.defaults.timeout = 5000; // 5 segundos de timeout
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Interceptor para requisições
axios.interceptors.request.use(
    config => {
        // Adiciona um timestamp para evitar cache
        config.params = {
            ...config.params,
            _t: Date.now()
        };
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Interceptor para respostas
axios.interceptors.response.use(
    response => response,
    error => {
        // Se for erro de rede, não propaga o erro para o console
        if (error.code === 'ERR_NETWORK') {
            toast.error('Não foi possível conectar ao servidor. Verifique se o backend está rodando.');
            return Promise.resolve({ data: null }); // Retorna um objeto vazio ao invés de rejeitar
        }

        if (error.response) {
            if (error.response.status === 401) {
                logout();
            } else if (error.response.status >= 500) {
                toast.error('Erro interno do servidor. Tente novamente mais tarde.');
            } else if (error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Ocorreu um erro inesperado. Tente novamente.');
            }
        }

        return Promise.reject(error);
    }
);

export const makeRequest = (params: AxiosRequestConfig) => {
    return axios({
        ...params,
        baseURL: BASE_URL
    });
}

export const makePrivateRequest = (params: AxiosRequestConfig) => {
    const sessionData = getSessionData();
    
    const headers = {
        'Authorization': `Bearer ${sessionData.access_token}`
    }

    return makeRequest({ ...params, headers })
}

export const makeLogin = (loginData: LoginData) => {
    const token = `${CLIENT_ID}:${CLIENT_SECRET}`;

    const headers = {
        Authorization: `basic ${window.btoa(token)}`,
        'Content-Type': 'application/x-www-form-urlencoded'
    }

    const payload = qs.stringify({...loginData, grant_type: 'password'});
    
    return makeRequest({url:'/oauth/token', data: payload, method: 'POST', headers });
}